export type BidProbability = {
  price: number
  probability: number
}

/** returns probability from 0 ~ 100 */
export function getClosestProbability(price: number, probabilities: BidProbability[] = []) {
  if (!probabilities.length) {
    return undefined
  }

  return (
    probabilities.reduce((previousValue, currentValue) => {
      const previousValueDiff = Math.abs(previousValue.price - price)
      const currentValueDiff = Math.abs(currentValue.price - price)

      if (previousValueDiff === currentValueDiff) {
        return previousValue.price > currentValue.price ? previousValue : currentValue
      } else {
        return currentValueDiff < previousValueDiff ? currentValue : previousValue
      }
    })?.probability * 100 || 0
  )
}

export function getBidPriceWithLowestProbability(probabilities?: BidProbability[]) {
  return probabilities?.[probabilities.length - 1]?.price || undefined
}
